import Room from '../../../../features/room/Room';
import { useBackgroundData } from '../../../../../hooks/useBackgroundData';
import useCustomBridge from '../../../../../hooks/useCustomBridge';
import Actions from '../Actions/Actions';
import Head from '../Head/Head';
import { useContent } from '../../../../../redux/reducer/content';

export default function Content() {
  const { viewedFriend } = useContent();

  const shareRoomItems = useBackgroundData({ items: viewedFriend?.items, extraRoom: viewedFriend?.eventRoomId });

  useCustomBridge();

  return (
    <div className={'share'}>
      <div className={'share__bg'}>
        <Room clothItems={viewedFriend?.items} roomItems={shareRoomItems} />
      </div>
      <div className={'share__content'}>
        <Head />
        <Actions />
      </div>
    </div>
  );
}
